// extracted by mini-css-extract-plugin
module.exports = {"leftRight":"leftRight___3Q_yX","Slider":"Slider___2b74D","rightContent":"rightContent____cvQA","rightContent_inner":"rightContent_inner___25IaG"};